<div class="inline-flex items-center gap-3 bg-peps-dark-700/80 border border-peps-gold/40 pl-2 pr-5 py-2 backdrop-blur-sm"
     style="box-shadow: 0 0 24px rgba(238,201,50,0.25), inset 0 0 0 1px rgba(238,201,50,0.08);">
	<div class="flex items-center justify-center w-9 h-9 rounded-full bg-peps-gold/10 shrink-0">
		<img src="assets/images/pepscoins.png" alt="" class="w-6 h-6">
	</div>
	<div class="flex flex-col leading-none gap-1">
		<span class="text-2xl font-dinpro text-peps-gold tabular-nums">{{ coins }}</span>
		<span class="text-[10px] uppercase font-dinpro-medium text-peps-dark-200/50 tracking-[0.2em]">PepsCoins</span>
	</div>
</div>
